export function ErrorSolidRedIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <g clipPath="url(#clip0_769_16021)">
        <path d="M4 4H8V8H4V4Z" stroke="white" strokeWidth="8" />
        <path
          d="M6 -6.10352e-05C2.682 -6.10352e-05 0 2.68194 0 5.99994C0 9.31794 2.682 11.9999 6 11.9999C9.318 11.9999 12 9.31794 12 5.99994C12 2.68194 9.318 -6.10352e-05 6 -6.10352e-05ZM9 8.15394L8.154 8.99994L6 6.84594L3.846 8.99994L3 8.15394L5.154 5.99994L3 3.84594L3.846 2.99994L6 5.15394L8.154 2.99994L9 3.84594L6.846 5.99994L9 8.15394Z"
          fill="#EF4444"
        />
      </g>
      <defs>
        <clipPath id="clip0_769_16021">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
